export default __webpack_public_path__ + "static/media/steak4.7ac53492.png";